import React from "react";
import { canOpenAppSettings, openApplicationSettings } from "../../cordova_plugins";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppModalAction, ErrorModal } from "../Generic/AppModal/AppModal";

export interface PromptClockRejectedModalProps {
  isOpen: boolean;
  onRequestTechnicalSupport: () => void;
  onRequestClose: () => void;
}

const PromptClockRejectedModal = (props: PromptClockRejectedModalProps) => {
  const callTechnicalSupportAction: AppModalAction = {
    key: "call_support",
    variant: "soft",
    color: "danger",
    children: translate(STRINGS.TECHNICAL_SUPPORT),
    onClick: props.onRequestTechnicalSupport,
  };

  const openSettingsAction: AppModalAction = {
    key: "open_settings",
    variant: "soft",
    color: "primary",
    children: translate(STRINGS.OPEN_SETTINGS),
    onClick: openApplicationSettings,
  };

  const actions: AppModalAction[] = [
    canOpenAppSettings() ? openSettingsAction : callTechnicalSupportAction,
    {
      key: "close",
      variant: "link",
      color: "black",
      children: translate(STRINGS.CLOSE),
      onClick: props.onRequestClose,
    },
  ];

  return (
    <ErrorModal
      isOpen={props.isOpen}
      title={translate(STRINGS.PLEASE_ENABLE_LOCATION)}
      message={translate(STRINGS.UNAVAILABLE_LOCATION_SERVICES_MESSAGE)}
      actions={actions}
      onRequestClose={props.onRequestClose}
    />
  );
};

export default PromptClockRejectedModal;
